import { render, staticRenderFns } from "./pendingExamina.vue?vue&type=template&id=4ae64948"
import script from "./pendingExamina.vue?vue&type=script&lang=js"
export * from "./pendingExamina.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/tentacles/servers/appservers/video-admin-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4ae64948')) {
      api.createRecord('4ae64948', component.options)
    } else {
      api.reload('4ae64948', component.options)
    }
    module.hot.accept("./pendingExamina.vue?vue&type=template&id=4ae64948", function () {
      api.rerender('4ae64948', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/brokerManage/components/pendingExamina.vue"
export default component.exports